// src/pages/Home.jsx
import { Link } from 'react-router-dom';
import { useLang } from '../lib/i18n.jsx';
import LanguageToggle from '../components/LanguageToggle.jsx';

export default function Home() {
  const { t } = useLang();
  return (
    <div className="min-h-screen flex flex-col">
      <header className="flex items-center justify-between px-6 py-5">
        <div className="font-display text-lg font-semibold text-sage-600">Sauti</div>
        <LanguageToggle />
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-md text-center">
          <h1 className="font-display text-3xl font-semibold text-ink leading-tight">{t.heroTitle}</h1>
          <p className="mt-4 text-ink/70 leading-relaxed">{t.heroBody}</p>

          <Link
            to="/chat"
            className="mt-8 inline-flex items-center justify-center rounded-full bg-coral hover:bg-coral-600 text-white font-medium px-8 py-3.5 text-base shadow-md animate-breathe transition-colors"
          >
            {t.cta}
          </Link>

          <div className="mt-6">
            <Link to="/resources" className="text-sm text-sage-600 underline underline-offset-2 hover:text-sage">
              {t.resourcesLink}
            </Link>
          </div>
        </div>
      </main>

      <footer className="px-6 py-5 text-center text-xs text-ink/50 max-w-lg mx-auto">
        {t.disclaimer}
      </footer>
    </div>
  );
}
